var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs flex items-center uppercase",class:[_vm.padding]},[_c('span',{staticClass:"mr-3 text-gray-600"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"w-auto flex-grow"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }